import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VideoConfirmationDialogComponent } from '../video-confirmation-dialog/video-confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from '../../service/chat-service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EXP_DATE_MSG } from '../../utility/constant-config';
import { Router } from '@angular/router';
import { InteractionService } from '../../service/interaction/interaction.service';
import { Subscription, take } from 'rxjs';

@Component({
    selector: 'app-document-expiry',
    templateUrl: './document-expiry.component.html',
    styleUrl: './document-expiry.component.scss',
    standalone: false
})
export class DocumentExpiryComponent {
  @Input() min: any;
  yesterday = new Date();
  userId: any;
  abioFocusApiText = ""
  abioFocusText = ""
  selectedFileName: string;
  day1 = new Date().setDate(new Date().getDate() + 1);
  day7 = new Date().setDate(new Date().getDate() + 7);
  day17 = new Date().setDate(new Date().getDate() + 17);
  month1 = new Date().setMonth(new Date().getMonth() + 1);
  year1 = new Date().setFullYear(new Date().getFullYear() + 1);
  availableDates = [
    {
      label: "1 Day",
      date: this.day1
    },
    {
      label: "7 Days",
      date: this.day7
    },
    {
      label: "17 Days",
      date: this.day17
    },
    {
      label: "1 Month",
      date: this.month1
    },
    {
      label: "1 Year",
      date: this.year1
    },
    {
      label: "Custom Date",
      date: "null"
    }
  ];
  docExpiryForm: FormGroup;
  defaultExpiryDate: any;
  summaraizerSubscription: any = new Subscription();
  docExp: any;

  constructor(public dialogRef: MatDialogRef<VideoConfirmationDialogComponent>,
    private readonly toastr: ToastrService, private fb: FormBuilder,private router: Router, public intService: InteractionService, public ChatService: ChatService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public chatService: ChatService) {
      this.yesterday.setDate(this.yesterday.getDate() - 0);
  }

  ngOnInit() {
    this.userId = Number(sessionStorage.getItem('userId'));
    this.abioFocusText = this.abioFocusApiText = 'Summarizer';
    this.selectedFileName = this.data.file.name;
    this.initializeForm();
  }

  initializeForm(): void {
    this.docExpiryForm = this.fb.group({
      expType: [this.availableDates[1], Validators.required],
      expDate: [new Date(this.availableDates[1].date), Validators.required],
    });
  }

  closeOnClick(): void {
  this.sendBackgroundSummary('No');
  }

  selectFileExt(selectedValues) {
    this.docExpiryForm.controls["expDate"].setValue(new Date(selectedValues.date))
    this.docExpiryForm.controls["expDate"].updateValueAndValidity();
    this.docExpiryForm.controls["expDate"].markAsTouched();
  }

  expiryDate(event) {
    const selectedDate = this.getFormattedDate(event.value);
    let selectedItem = this.availableDates.find(item => this.getFormattedDate(item.date) === selectedDate);
    if (selectedItem) {
      this.docExpiryForm.controls["expType"].setValue(selectedItem)

    } else {
      this.docExpiryForm.controls["expType"].setValue(this.availableDates[this.availableDates.length - 1])
    }

  }

  submit() {
    this.docExpiryForm.markAllAsTouched();
    this.docExpiryForm.markAsDirty();
    let expiryDateValue = this.docExpiryForm.controls['expDate'].value;
    this.defaultExpiryDate = new Date();
    this.defaultExpiryDate.setDate(this.defaultExpiryDate.getDate() + 7);
    if (!expiryDateValue) {
        expiryDateValue =  this.defaultExpiryDate;
    }
    if (expiryDateValue) {
      const selectedDate = this.getFormattedDate(expiryDateValue);
      const data = {
        expiryDate: selectedDate,
        event: this.data.event
      };

      if (!this.data?.value?.popup) {
        this.chatService.summarizerDocExpDate$.next(data);
      }
      if (this.data.result) {
      this.sendBackgroundSummary('Yes',{
        showToast: false, Expdate: selectedDate,
        onSuccess: (res) => {
          this.intService.setChatStatus({ chat_identifier: 'newchat' });
          this.router.navigate(['/app-abiomed-chat'], { queryParams: { chat: 'NC' }, skipLocationChange: true });
          this.toastr.info(res.message);
        }
      });
    }
    this.dialogRef.close(true);
    } else {
      this.toastr.error(EXP_DATE_MSG);
    }
  }
  private sendBackgroundSummary(userResponse: string, options?: {onSuccess?: (res: any) => void; showToast?: boolean;Expdate?:any}): void {
     this.defaultExpiryDate = new Date();
    this.defaultExpiryDate.setDate(this.defaultExpiryDate.getDate() + 7);
    const request = {
      chat_user_id: this.userId,
      business_unit_code: sessionStorage.getItem('businessUnitCode'),
      chat_session_id: this.data?.id,
      user_response: userResponse,
      expiry_date: options?.Expdate || this.getFormattedDate(this.defaultExpiryDate)
    };
    const selectedFile = this.data?.event?.srcElement?.files?.[0];

    this.ChatService.summarizeBackground(selectedFile, request).subscribe({
      next: (res) => {
        if (options?.showToast ?? true) {
          this.toastr.info(res.message);
        }
        if (options?.onSuccess) {
          options.onSuccess(res);
        }
      },
      error: () => {
        this.toastr.error('Error processing request');
      }
    });
    this.dialogRef.close(true);
  }

  getFormattedDate(date) {
    const selectedDate = new Date(date);
    const yyyy = selectedDate.getFullYear();
    let mm: any = selectedDate.getMonth() + 1; // Months start at 0!
    let dd: any = selectedDate.getDate();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return yyyy + '-' + mm + '-' + dd;
  }
  
}
